import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Rating from "./sub-components/ProductRating";
import RenderSmoothImage from 'render-smooth-image-react';
import 'render-smooth-image-react/build/style.css';

const ProductGridListSingle = ({
  product,
  currency,
  sliderClassName,
  spaceBottomClass,
}) => {
 
 
  return (
    <>
      <div className={`col-xl-4 col-sm-6 ${sliderClassName || ""}`}>
        <div className={`product-wrap ${spaceBottomClass || ""}`}>
          <div className="product-img">
            <Link to={`${process.env.PUBLIC_URL}/paseo/${product._id}`}>
            <RenderSmoothImage src={product.images && product.images.length > 0 && product.images[0] && product.images[0].url} alt="alternate-text"  />
              
            </Link>
            <div className="product-action">
              <div
                className="pro-same-action pro-cart"
                style={{ width: "100%" }}
              >
                  <Link to={`${process.env.PUBLIC_URL}/paseo/${product._id}`}>
                  Ver más
                  </Link>
                
              </div>
            </div>
          </div>
            <h3>
              <Link to={`${process.env.PUBLIC_URL}/paseo/${product._id}`}>
                {product.name}
              </Link>
            </h3>
        </div>
      </div>
    </>
  );
};

ProductGridListSingle.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.object,
};

export default ProductGridListSingle;
